import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import FormGroup from 'Components/FormGroup/FormGroup';
import Accordion from 'Common/Accordion/Accordion';
import ReviewRoundReports from '../containers/ReviewRoundReports';
import { TYPE_INTERNAL, TYPE_BOARD_MEMBER } from 'Constants';

export default class ReviewRounds extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        rounds: PropTypes.array.isRequired,
    };

    static filter = {
        where: { type: { inq: [TYPE_INTERNAL, TYPE_BOARD_MEMBER] } },
    };

    render() {
        const { rounds } = this.props;

        return (
            <div>
                {rounds.length > 1 && (
                    <FormGroup title="field.previous_review_rounds.label">
                        <Accordion
                            collapses={rounds.slice(0, -1).map(round => {
                                return {
                                    title: (
                                        <div className="accordion-title-wrapper round-report-accordion-title-wrapper">
                                            Round {round.round}
                                        </div>
                                    ),
                                    content: (
                                        <div className="accordion-body-wrapper round-report-table-wrapper">
                                            <ReviewRoundReports
                                                round={round.id}
                                                customFilter={this.constructor.filter}
                                            />
                                        </div>
                                    ),
                                };
                            })}
                            classes={{
                                expansionPanel: 'assign-accordion-collapse-wrapper',
                                expansionPanelExpanded: 'assign-accordion-collapse-expanded-wrapper'
                            }}
                        />
                    </FormGroup>
                )}
                <FormGroup title="field.current_review_round.label">
                    <ReviewRoundReports round={rounds[rounds.length - 1].id} customFilter={this.constructor.filter} />
                </FormGroup>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/components/ReviewRounds.jsx